import { MessageModalProps } from "core/utils/modals";
import flow from "lodash/flow";
import { QuestionCircle } from "react-bootstrap-icons";
import { LightButton, PrimaryButton } from "../../buttons/buttons";
import Modal from "../modal/modal";

export interface ConfirmModalProps extends MessageModalProps {
	acceptText?: string;
	onAccept: VoidFunction;
	cancelText?: string;
	onCancel: VoidFunction;
}

export const ConfirmModal = (props: ConfirmModalProps) => {
	const footer = (close: VoidFunction) => (
		<>
			<LightButton onClick={flow(props.onCancel, close)}>
				{props.cancelText ?? "Cancelar"}
			</LightButton>
			<PrimaryButton onClick={flow(props.onAccept, close)}>
				{props.acceptText ?? "Aceptar"}
			</PrimaryButton>
		</>
	);

	return (
		<Modal parent={props.parent} footer={footer} onClosed={props.onCancel}>
			<div className="text-center">
				<QuestionCircle className="modal-icon" /><br />
				<strong>{props.message}</strong>
			</div>
		</Modal>
	);
};

export default ConfirmModal;